module.exports = __webpack_public_path__ + "static/media/la.562dda74.svg";